import { Box, Stack, Text, Image } from '@chakra-ui/react';
import { LoaderOverlay } from 'components/LoaderOverlay/LoaderOverlay';
import { FormattedMessage } from 'react-intl';
import { useOrderHistory } from './hooks/useOrderHIstory';
import { HistoryCard } from 'components/HistoryCard/HistoryCard';
import fallbackPlaceholder from 'assets/placeholder.svg';

export const OrderHistory = () => {
  const { isLoading, data } = useOrderHistory();
  if (isLoading && !data) {
    return <LoaderOverlay />;
  }

  const historyItems = Array.isArray(data) ? data : [];
  const hasHistory = historyItems.length > 0;

  return (
    <Box paddingBottom='16px' w='100%' display='flex' flexDirection='column' alignItems='center'>
      <Box
        w='100%'
        maxW={{ base: '100%', md: '640px', lg: '800px', xl: '900px' }}
        textAlign='right'
      >
        <Text variant='bodyLargestRegular'>
          <FormattedMessage id='history.heading' defaultMessage={'Your purchases'} />
        </Text>
        <Text mt={'12px'} textStyle='bodySmallRegular' color='gray.600'>
          <FormattedMessage
            id='history.caption'
            defaultMessage={'هنا يمكنك عرض تفاصيل جميع مشترياتك السابقة.'}
          />
        </Text>
      </Box>
      <Box
        as='section'
        mt={hasHistory ? 6 : 3}
        w='100%'
        display='flex'
        justifyContent='center'
        alignItems='center'
      >
        <Box
          as='ul'
          w='100%'
          maxW={{ base: '100%', md: '640px', lg: '800px', xl: '900px' }}
          listStyleType='none'
          p={0}
          m={0}
        >
          <Stack
            spacing={{ base: hasHistory ? 4 : 3, md: hasHistory ? 5 : 4 }}
            align='stretch'
            w='100%'
          >
            {hasHistory ? (
              historyItems.map((historyItem) => (
                <HistoryCard key={historyItem.id} historyElement={historyItem} />
              ))
            ) : (
              <Box
                role='status'
                aria-live='polite'
                display='flex'
                alignItems='center'
                justifyContent='center'
                flexDirection='column'
                py={{ base: 6, md: 7 }}
                px={{ base: 4, md: 6 }}
                gap={4}
                maxW='520px'
                mx='auto'
                textAlign='center'
              >
                <Text textStyle='bodySmallRegular' color='gray.600' textAlign='center' mb={2}>
                  <FormattedMessage
                    id='history.emptyState.message'
                    defaultMessage={'لم تقم بشراء أي تذكرة بعد'}
                  />
                </Text>
                <Image
                  src='https://media.tenor.com/JHTko1DVhdsAAAAM/kermit-the-frog-kermit.gif'
                  alt='Waiting'
                  width={{ base: '120px', md: '140px' }}
                  height='auto'
                  mt={2}
                  borderRadius='md'
                  onError={(e) => {
                    const target = e.currentTarget;
                    if (target.src !== fallbackPlaceholder) {
                      target.src = fallbackPlaceholder as unknown as string;
                    }
                  }}
                />
              </Box>
            )}
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};
